import React, { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Col, Container, Row } from "react-bootstrap";
import SelectDropDown from "../component/SelectDropDown";
import InputField from "../component/InputField";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import OtherService from "../services/Other";
import RegistrationService from "../services/registration";
import AlertMsg from "../component/AlertMsg";
import ProfileService from "../services/Profile";
import DefaultImage from "../assets/images/logo-small.png";
import { useNavigate } from "react-router-dom";
import { API_IMAGE_BASE_URL } from "../constants/common";
import toast from "react-hot-toast";
import PurchaseService from "../services/Purchase";
import { useDispatch, useSelector } from "react-redux";
import {
  isMobileNumberValid,
  ValidatePhoneNumber,
} from "../constants/commonFunction";
import { addPurchase } from "../redux/slices/currentPurchase";
import { addPurchaseProductList } from "../redux/slices/currentUserSlice";
import { addHierarchiesList, addHierarchiesDetails } from "../redux/slices/hierarchiesSlice";
import Modal from "../component/Modal";
import Form from "react-bootstrap/Form";
import { DatePicker } from "antd";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
const dateFormat = 'YYYY-MM-DD';

const PurchaseRegistration = () => {
  const dispatch = useDispatch();
  const currentPurchase = useSelector(
    (state) => state.currentPurchase.currentPurchase
  );
  const userInfoData = JSON.parse(localStorage.getItem("userData") || "{}");
  const userInfo = userInfoData.description;
  console.log("Usrinfo----->", userInfo);
  
  const currentBrand = useSelector((state) => state.userTypeSlice.currentBrand);
  const hierarchiesList = useSelector((state) => state.hierarchies.hierarchiesList);
  const hierarchiesDetails = useSelector((state) => state.hierarchies.hierarchiesDetails);
  const purchaseProductList = useSelector((state) => state.currentUser.purchaseProductList);
  const purchaseProductBrandId = useSelector((state) => state.currentUser.purchaseProductBrandId);
  const location = useLocation();
  const { dealerContactId } = location.state || {};
  const navigate = useNavigate();

  //USE STATE
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isProduct, setIsProduct] = useState({
    id: currentPurchase ? currentPurchase.dcm_product_master_id : "",
    title: currentPurchase ? currentPurchase.product_description : "",
    productImage: "",
  });
  const [showNumList, setShowNumList] = useState(false);
  const [selectPersonaValidationError, setSelectPersonaValidationError] =
    useState("");
  const [isProductList, setIsProductList] = useState([]);
  const [isPersonaList, setIsPersonaList] = useState([]);
  const [selectPersonaList, setSelectPersonaList] = useState({
    id: "",
    title: "",
  });
  const [isInfluencerList, setIsInfluencerList] = useState([]);
  const [selectInfluencerList, setSelectInfluencerList] = useState({
    id: "",
    title: "",
  });
  const [allNumbers, setAllNumbers] = useState([]);
  const [editableSiteDetails, setEditableSiteDetails] = useState(true);
  const [isPersona, setIsPersona] = useState({ id: "", title: "" });
  const [isDealer, setIsDealer] = useState({ id: "", title: "" });
  const [isLoginSuccess, setIsLoginSuccess] = useState({
    isLogin: true,
    heading: "",
    text: "",
  });
  const [showAlert, setShowAlert] = useState(false);
  const [isBrand, setIsBrand] = useState([]);
  const [isBrandSelect, setIsBrandSelect] = useState({ id: "", title: "" });
  const [dealerList, setDealerList] = useState([]);
  const [dealerSelectList, setDealerSelectList] = useState([]);
  const [isDealerChoose, setIsDealerChoose] = useState({
    id: "",
    title: "",
  });
  const [purchase, setPurchase] = useState({
    ownerName: currentPurchase ? currentPurchase.customer_name : "",
    site: currentPurchase ? currentPurchase.site_name : "",
    mobile: currentPurchase ? currentPurchase.mobile : "",
    constructionArea: "",
    unitPrice: "",
    totalBag: "",
    purchaseDate: "",
  });
  const [productNameValidationError, setProductNameValidationError] =
    useState("");
  const [custId, setCustId] = useState("");
  const [dealerValidationError, setDealerValidationError] = useState("");
  const [unitPriceValidationError, setUnitPriceValidationError] = useState("");
  const [bagPurchasedValidationError, setBagPurchaseValidationError] =
    useState("");
  const [purchaseDateValidationError, setPurchaseDateValidationError] =
    useState("");
  const [customerNameValidationError, setCustomerNameValidationError] =
    useState("");
  const [customerNumberValidationError, setCustomerNumberValidationError] =
    useState("");
  const [mobileNoValidationError, setMobileNoValidationError] = useState("");
  const [siteValidationError, setSiteValidationError] = useState("");
  const [constructionValidationError, setConstructionValidationError] =
    useState("");
  const [brandValidationErrors, setBrandValidationError] = useState("");
  const [loginuserHierarchy, setLoginuserHierarchy] = useState("");
  const [influencerBrand, setInfluencerBrand] = useState("");
  const [numberRequiredValidation, setNumberRequiredValidation] = useState("");
  const [influencerNameValidationError, setInfluencerNameValidationError] =
    useState("");
  const [isDealerSearchOpen, setIsDealerSearchOpen] = useState(false);
  const [formData, setFormData] = useState({
    dealer_contact_id: 0,
    ownerName: currentPurchase ? currentPurchase.customer_name : "",
    site: currentPurchase ? currentPurchase.site_name : "",
    mobile: currentPurchase ? currentPurchase.mobile : "",
    constructionArea: "",
    unitPrice: currentPurchase ? currentPurchase.unit_price : "",
    totalBag: "",
    purchaseDate: "",
  });
  const [externalSearchText, setExternalSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [pastDays, setPastDays] = useState(15);

  const handleInfluencerChange = (selectedValue) => {
    setSelectInfluencerList(selectedValue);
    setInfluencerNameValidationError("");
  };

  useEffect(() => {
    setIsBrandSelect(currentBrand);
    return () => {
      dispatch(addPurchase({ currentPurchase: null }));
    };
  }, []);


  const getDateRange = useCallback(async () => {
    const res = await PurchaseService.getDateRange();
    console.log('date range res', JSON.stringify(res));
    if (res.success && res.response?.purchaseDateConfiguation?.length > 0) {
      const confValue = parseInt(res.response.purchaseDateConfiguation[0].conf_value, 10);
      if (!isNaN(confValue)) {
        setPastDays(confValue-1);
      }
    }
  }, []);

  useEffect(() => {
    getDateRange();
  }, [getDateRange]);

  useEffect(() => {
    if (purchase.mobile.length >= 2) {
      const toid = setTimeout(() => {
        PurchaseService.autoSuggestion(purchase.mobile).then((res) => {
          if (res.success) {
            const datas = res.response.customerDetails.map((item) => ({
              id: item.id,
              title: item.mobile,
              siteOwnerName: item.name,
              siteName: item.site_name,
              proposedArea: item.proposed_area,
              dealerContactId: dealerContactId,
            }));
            if (purchase.mobile.length == 10) {
              setAllNumbers([]);
              if (datas.length > 0) {
                setPurchase((p) => ({
                  ...p,
                  ownerName: datas[0].siteOwnerName,
                  constructionArea: datas[0].proposedArea,
                  dealerContactId: datas[0].dealerContactId || 0,
                }));
                setCustId(String(datas[0].id));
                setEditableSiteDetails(false);
              } else {
                setEditableSiteDetails(true);
              }
              return;
            }
            setAllNumbers(datas);
            setCustId("");
            setShowNumList(true);
          }
        });
      }, 800);
      return () => {
        clearTimeout(toid);
      };
    } else {
      setEditableSiteDetails(true);
      setPurchase((p) => ({ ...p, ownerName: "", constructionArea: "" }));
    }
  }, [purchase.mobile]);

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userData"));
    const hierId = userInfo.dcm_hierarchies_id;
    const InfluencerBrand = userInfo.dcm_brands_id;
    setInfluencerBrand(InfluencerBrand);
    setLoginuserHierarchy(hierId);
  }, []);

  useEffect(() => {
    if (hierarchiesList && hierarchiesList.length > 0) {
      setIsPersonaList(hierarchiesList);
      return;
    }
    const hierarchiesFetchData = async () => {
      try {
        const hierchiesFetchDataResponse = await OtherService.hierarchiesList();
        const hierchiesList =
          hierchiesFetchDataResponse.response.hierarchiesDetails.map(
            (item) => ({
              id: item.hireId,
              title: item.description,
            })
          );
        setIsPersonaList(hierchiesList);
        dispatch(addHierarchiesList({ hierarchiesList: hierchiesList }));
        dispatch(
          addHierarchiesDetails({
            hierarchiesDetails: hierchiesFetchDataResponse.response.hierarchiesDetails,
          })
        );
      } catch (error) {
        console.error("Error fetching hierarchies:");
      }
    };
    hierarchiesFetchData();
  }, []);

  useEffect(() => {
    const PersonaSelectionList = async () => {
      try {
        const PersonaSelectFetch = await RegistrationService.getHierarchies();
        if (PersonaSelectFetch.success == true) {
          if (PersonaSelectFetch.response.hierarchiesDetails.length > 0) {
            const hierchiesList =
              PersonaSelectFetch.response.hierarchiesDetails.map((item) => ({
                id: item.id,
                title: item.name,
              }));
            setIsPersonaList(hierchiesList);
          }
        }
      } catch (e) {
      }
    };
    PersonaSelectionList();
  }, []);
  useEffect(() => {
    const BrandFetch = async () => {
      try {
        const brandResponse = await ProfileService.getBrand();
        const brands = brandResponse?.response?.message.map((item) => ({
          id: item.brandId,
          title: item.brandName,
        }));
        setIsBrand(brands);
      } catch (error) {
        console.error("Brand Fetch");
      }
    };
    BrandFetch();
  }, []);

  useEffect(() => {
    if (!hierarchiesDetails || hierarchiesDetails.length === 0) {
      return;
    }
    let arr = [];
    hierarchiesDetails.forEach((item) => {
      if (item.description === "Dealer") {
        arr.push(item);
      }
    });
    arr.forEach((member) => {
      if (influencerBrand == 1 && member.hierCode == "dealerAcc") {
        setDealerList({
          id: member.hireId,
          title: member.title,
        });
      }
      if (influencerBrand == 2 && member.hierCode == "dealerAcl") {
        setDealerList({
          id: member.hireId,
          title: member.title,
        });
      }
    });
  }, [isBrand, hierarchiesDetails]);

  const ChooseDealerListFetch = async () => {
    try {
      const ChooseDealerListResponse =
        await RegistrationService.salesGetAllDealers();
        
      if (
        ChooseDealerListResponse.success === true &&
        ChooseDealerListResponse.response.dealerDetails.length > 0
      ) {
        const dealerDetails = ChooseDealerListResponse.response.dealerDetails;
        const filteredDealer = dealerDetails.map((item) => ({
          id: item.id,
          title: `${item.full_name} (${item.dealer_business_name} - ${item.id_extern01})`,
        }));        
        setDealerSelectList(filteredDealer);

        const foundDealer = filteredDealer.find(d => d.id == currentPurchase?.dealer_id);
        if(foundDealer)
          setIsDealerChoose(foundDealer)
        const defaultDealerId = dealerDetails[0].id;

        setFormData((prev) => ({
          ...prev,
          dealer_contact_id: defaultDealerId,
        }));
      }
    } catch (error) {
      console.error("ChooseDealerListFetch");
    }
  };

  useEffect(() => {
    if (dealerList && Object.keys(dealerList).length > 0) {
      ChooseDealerListFetch();
    }
  }, [dealerList]);

  useEffect(() => {
    if (!isBrandSelect.id) {
      return;
    }
    if (
      purchaseProductBrandId === isBrandSelect.id &&
      purchaseProductList &&
      purchaseProductList.length > 0
    ) {
      setIsProductList(purchaseProductList);
      return;
    }
    const ChooseProductListFetch = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("access_token");
        const ChooseProductListFetchResponse =
          await RegistrationService.getProductNames(isBrandSelect.id, token);
        if (
          ChooseProductListFetchResponse.success == true &&
          ChooseProductListFetchResponse.response.ProductDetails.length > 0
        ) {
          const filteredProduct =
            ChooseProductListFetchResponse.response.ProductDetails.map(
              (item, index) => {
                const productImageSrc =
                  item.product_image == null
                    ? DefaultImage
                    : `${API_IMAGE_BASE_URL}${item.product_image}`;
                return {
                  id: item.id,
                  title: item.product_name,
                  image: { uri: productImageSrc },
                };
              }
            );
          setIsProductList(filteredProduct);
          dispatch(
            addPurchaseProductList({
              purchaseProductList: filteredProduct,
              purchaseProductBrandId: isBrandSelect.id,
            })
          );
        }
      } catch (e) {
        console.error("ChooseProductListFetch");
      } finally {
        setLoading(false);
      }
    };
    ChooseProductListFetch();
  }, [isBrandSelect]);

  useEffect(() => {
    const InfluencerFetch = async () => {
      try {
        const token = localStorage.getItem("access_token");
        console.log("selectPersonaList", selectPersonaList.id);
        if (!selectPersonaList.id) {
          return;
        }
        const InfluencerFetchResponse =
          await RegistrationService.getInfluencers(selectPersonaList.id, token);
        if (InfluencerFetchResponse.success == true) {
          if (
            InfluencerFetchResponse.response.saleContractorDetails.length > 0
          ) {
            setIsInfluencerList(
              InfluencerFetchResponse.response.saleContractorDetails.map(
                (item) => {
                  return {
                    id: item.dcm_contacts_id,
                    title: item.full_name,
                  };
                }
              )
            );
          }
        }
      } catch (e) {
      }
    };
    InfluencerFetch();
  }, [selectPersonaList.id]);

  const handleProductChange = (selectedValue) => {
    setIsProduct(selectedValue);
    setProductNameValidationError("");
  };

  const handlePersonaChange = (selectedValue) => {
    setIsPersona(selectedValue);
    setSelectPersonaValidationError("");
  };

  const handleDealerChange = (selectedValue) => {
    setIsDealer(selectedValue);
    setDealerValidationError("");
  };

  const handlePurchaseRegistrationInput = (e) => {
    let value = e.target.value;
    const fieldName = e.target.name;
    const numberPattern = /^\d*$/;
    const mobileRegex = /^\d{10}$/; 
    if (fieldName == "ownerName") {
      const customerNameRegex = /^[a-zA-Z\s]*$/;
      // /^[a-zA-Z\s]*$/;
      if (customerNameRegex.test(value) || value.length === 0) {
        setCustomerNameValidationError("");
      } else {
        setCustomerNameValidationError("Invalid customer name");
        return;
      }
    }
    if (fieldName === "mobile") {
      if (mobileRegex.test(value)) {
        setMobileNoValidationError("");
      } else {
        setMobileNoValidationError("Invalid mobile no");
      }
    }
    if (
      fieldName === "constructionArea" ||
      fieldName === "unitPrice" ||
      fieldName === "totalBag"
    ) {
      if (!numberPattern.test(value)) {
        switch (fieldName) {
          case "constructionArea":
            setConstructionValidationError("Field value must be a number");
            break;
          case "unitPrice":
            setUnitPriceValidationError("Field value must be a number");
            break;
          case "totalBag":
            setBagPurchaseValidationError("Field value must be a number");
            break;
        }
        return; 
      }
    }
    switch (fieldName) {
      case "customerName":
        setCustomerNameValidationError("");
        break;
      case "mobile":
        break;
      case "site":
        setSiteValidationError("");
        break;
      case "constructionArea":
        setConstructionValidationError("");
        break;
      case "unitPrice":
        setUnitPriceValidationError("");
        break;
      case "totalBag":
        setBagPurchaseValidationError("");
        break;
      case "purchaseDate":
        setPurchaseDateValidationError("");
        break;
      case "ownerName":
        setCustomerNameValidationError("");
        break;
    }
    if (fieldName === "mobile" && !numberPattern.test(value)) return;
    setPurchase({ ...purchase, [fieldName]: value });
  };

  const handleBrandChange = (selected) => {
    setIsBrandSelect(selected);
    setBrandValidationError("");
  };

  const handlePurchaseRegistration = async () => {
    if (userInfo == "Dealer") {
      // let isValid = true;
      // const validations = [
      //   {
      //     value: isProduct.id,
      //     setter: setProductNameValidationError,
      //     message: "Product Name is required.",
      //   },
      //   {
      //     value: purchase.ownerName,
      //     setter: setCustomerNameValidationError,
      //     message: "Site Owner Name is required.",
      //   },
      //   {
      //     value: selectPersonaList.id,
      //     setter: setSelectPersonaValidationError,
      //     message: "Persona is required.",
      //   },
      //   {
      //     value: selectInfluencerList.id,
      //     setter: setInfluencerNameValidationError,
      //     message: "Influencer is required.",
      //   },
      //   {
      //     value: isDealer.id,
      //     setter: setDealerValidationError,
      //     message: "Dealer is required.",
      //   },
      //   {
      //     value: purchase.unitPrice,
      //     setter: setUnitPriceValidationError,
      //     message: "Unit Price is required.",
      //   },
      //   {
      //     value: purchase.totalBag,
      //     setter: setBagPurchaseValidationError,
      //     message: "Total Bag Purchased is required.",
      //   },
      //   {
      //     value: purchase.purchaseDate,
      //     setter: setPurchaseDateValidationError,
      //     message: "Purchase Date is required.",
      //   },
      //   {
      //     value: purchase.mobile,
      //     setter: setMobileNoValidationError,
      //     message: "Mobile No is required.",
      //   },
      //   {
      //     value: purchase.constructionArea,
      //     setter: setConstructionValidationError,
      //     message: "Construction Area is required.",
      //   },
      //   {
      //     value: isBrandSelect.id,
      //     setter: setBrandValidationError,
      //     message: "Brand is required.",
      //   },
      // ];
      // validations.forEach(({ value, setter, message }) => {
      //   if (!value) {
      //     setter(message);
      //     isValid = false;
      //   } else {
      //     setter(""); // Clear the error message
      //   }
      // });
      // const token = localStorage.getItem('access_token');
      // const externaID = JSON.parse(localStorage.getItem('userData'));
      // const payload = {
      //   "customer_name": purchase.ownerName,
      //   "hidden_unit": 0,
      //   "id_extern01": String(externaID),
      //   "mobile_number": purchase.mobile,
      //   "product_master_id": isProduct.id,
      //   "proposed_area": purchase.constructionArea,
      //   "sale_date": purchase.purchaseDate,
      //   "select_contractor": selectInfluencerList.id,
      //   "site_name": "",
      //   "tonnage_sold": parseInt(purchase.totalBag),
      //   "unit_price": parseInt(purchase.unitPrice)
      // };
      // if (isValid) {
      //   try {

      //     const PurchaseRegistrationSubmitDealer = await RegistrationService.dealerPurchaseRegistration(payload, token)

      //     if (PurchaseRegistrationSubmitDealer.success == true) {
      //       setShowAlert(true);
      //       setIsLoginSuccess({ isLogin: true, text: PurchaseRegistrationSubmitDealer.response.message });
      //       setTimeout(() => {
      //         setShowAlert(false);
      //         navigate("/purchase-registration-list")
      //       }, 2000)
      //     } else {
      //       setShowAlert(true);
      //       setIsLoginSuccess({ isLogin: false, text: PurchaseRegistrationSubmitDealer.response.message });
      //     }
      //   }
      //   catch (e) {

      //   }
      // }
    } else {
      // let isValid = true;
      // const validations = [
      //   {
      //     value: isProduct.id,
      //     setter: setProductNameValidationError,
      //     message: "Product Name is required.",
      //   },
      //   {
      //     value: purchase.ownerName,
      //     setter: setCustomerNameValidationError,
      //     message: "Site Owner Name is required.",
      //   },
      //   {
      //     value: isDealer.id,
      //     setter: setDealerValidationError,
      //     message: "Dealer is required.",
      //   },
      //   {
      //     value: purchase.unitPrice,
      //     setter: setUnitPriceValidationError,
      //     message: "Unit Price is required.",
      //   },
      //   {
      //     value: purchase.totalBag,
      //     setter: setBagPurchaseValidationError,
      //     message: "Total Bag Purchased is required.",
      //   },
      //   {
      //     value: purchase.purchaseDate,
      //     setter: setPurchaseDateValidationError,
      //     message: "Purchase Date is required.",
      //   },
      //   {
      //     value: purchase.mobile,
      //     setter: setMobileNoValidationError,
      //     message: "Mobile No is required.",
      //   },
      //   {
      //     value: purchase.constructionArea,
      //     setter: setConstructionValidationError,
      //     message: "Construction Area is required.",
      //   },
      //   {
      //     value: isBrandSelect.id,
      //     setter: setBrandValidationError,
      //     message: "Brand is required.",
      //   },
      // ];
      // validations.forEach(({ value, setter, message }) => {
      //   if (!value) {
      //     setter(message);

      //     isValid = false;
      //   } else {
      //     setter(""); // Clear the error message
      //   }
      // });
      if (!isBrandSelect.id) {
        return toast.error("Kindly choose brand");
      }
      if (!isProduct.id) {
        return toast.error("Kindly choose Product");
      }
      if (!purchase.totalBag) {
        return toast.error("Kindly enter quantity");
      }
      if (!purchase.purchaseDate) {
        return toast.error("Kindly enter purchase date");
      }
      if (!purchase.unitPrice) {
        return toast.error("Kindly enter unit price");
      }
      if (!purchase.ownerName) {
        return toast.error("Kindly enter site owner name");
      }
      if (!purchase.mobile) {
        return toast.error("Kindly enter site owner number");
      }
      if (!isMobileNumberValid(purchase.mobile)) {
        return toast.error("Kindly enter valid mobile number");
      }
      if (!purchase.constructionArea) {
        return toast.error("Kindly enter construction area");
      }
      if (!isDealerChoose.id) {
        return toast.error("Kindly enter dealer contact id");
      }
      const externaID = JSON.parse(localStorage.getItem("userData"));
      const payload = {
        contractor_hierarchy_id: parseInt(loginuserHierarchy),
        product: isProduct.id,
        tonnage_sold: parseInt(purchase.totalBag),
        sale_date: purchase.purchaseDate,
        dealer_contact_id:
          Number(isDealerChoose.id) ||
          Number(isDealer.id) ||
          Number(purchase.dealerContactId) ||
          Number(formData.dealer_contact_id),
        id_extern01: externaID.id_extern01,
        unit_price: parseInt(purchase.unitPrice),
        customer_name: purchase.ownerName,
        mobile_number: purchase.mobile,
        // site_name: "", //site
        site_name: purchase.site ? purchase.site : "",
        proposed_area: purchase.constructionArea,
        customer_id: custId,
      };
      try {
        setIsButtonLoading(true);
        const res = await RegistrationService.submitPurchaseRegistration(
          payload
        );
        if (res.success) {
          if (res.response.status === true) {
            toast.success(res.response.message);
            setTimeout(() => {
              navigate("/purchase-registration-list");
            }, 2000);
          } else {
            toast.error(res.response.message);
          }
        }
      } catch (error) {
        console.error("Error submitting purchase registration:");
      } finally {
        setIsButtonLoading(false);
      }
    }
  };

  function chooseNumber(item) {
    setCustId(String(item.id));
    setPurchase((p) => ({
      ...p,
      ownerName: item.siteOwnerName,
      constructionArea: item.proposed_area,
      mobile: item.title,
    }));
    // setMobNum(item.title);
    // setCustName(item.siteOwnerName);
    // setProposedArea(item.proposedArea);
    // setEditableSiteDetails(false);
    setTimeout(() => {
      setEditableSiteDetails(false);
      setAllNumbers([]);
    }, 1200);
  }

  const handlePurchaseDate = (date, dateString) => {
    setPurchase((prevPurchase) => ({
      ...prevPurchase,
      purchaseDate: dateString,
    }));
  };
  
  const today = new Date().toISOString().split("T")[0]; // max
  const fifteenDaysAgo = new Date(new Date().setDate(new Date().getDate() - 15))
    .toISOString()
    .split("T")[0]; // min

  const minDate = dayjs(fifteenDaysAgo, "YYYY-MM-DD");
  const maxDate = dayjs(today, "YYYY-MM-DD");

  const disabledDate = (current) => {
    return current < minDate.startOf("day") || current > maxDate.endOf("day");
  };

  return (
    <>
      <BreadCrumbSecttion
        pageTitle="Purchase Registration"
        currentPageName="Purchase Registration"
      />
      <section className="padTop50">
        <Container>
          <Row className="justify-content-center align-item-center h-100">
            <Col xs={12}>
              <div className="userInfoBox">
                <div className="dashboard-title ">
                  <h4 className="gradient-text">
                    Please Register Your Purchase
                  </h4>
                </div>
                <div className="dashboard-details middleWrapSelect">
                  <Row>
                    <Col xs={12} lg={6} className="mb-2">
                      <SelectDropDown
                        labelName="Brand"
                        requiredStar="*"
                        options={isBrand}
                        setSelectedValue={setIsBrandSelect}
                        selectedValue={isBrandSelect}
                        onChange={handleBrandChange}
                        disabled={true}
                      />
                      {/* {brandValidationErrors && (
                        <div className="error-message">
                          {brandValidationErrors}
                        </div>
                      )} */}
                    </Col>

                    <Col xs={12} lg={6} className="mb-2">
                      <SelectDropDown
                        labelName="Product Name"
                        requiredStar="*"
                        options={isProductList}
                        setSelectedValue={setIsProduct}
                        selectedValue={isProduct}
                        onChange={handleProductChange}
                        page="searchFilter"
                        hasImage={true}
                      />
                      {/* {productNameValidationError && (
                        <div className="error-message">
                          {productNameValidationError}
                        </div>
                      )} */}
                    </Col>

                    {userInfo == "Dealer" && (
                      <>
                        <Col xs={12} lg={6} className="mb-2">
                          <SelectDropDown
                            labelName="Select Persona"
                            requiredStar="*"
                            options={isPersonaList}
                            selectedValue={selectPersonaList}
                            setSelectedValue={setSelectPersonaList}
                            onChange={handlePersonaChange}
                            page="searchFilter"
                          />
                          {/* {selectPersonaValidationError &&
                            <div className="error-message">
                              {selectPersonaValidationError}
                            </div>} */}
                        </Col>
                        <Col xs={12} lg={6} className="mb-2">
                          <SelectDropDown
                            labelName="Select Influencer"
                            requiredStar="*"
                            options={isInfluencerList}
                            selectedValue={selectInfluencerList}
                            setSelectedValue={setSelectInfluencerList}
                            onChange={handleInfluencerChange}
                            page="searchFilter"
                          />
                          {/* {influencerNameValidationError &&
                            <div className="error-message">
                              {influencerNameValidationError}
                            </div>} */}
                        </Col>
                      </>
                    )}

                    <Col xs={12} lg={6} className="mb-2">
                      <InputField
                        inputFieldLabel="Quantity (Bags)"
                        requiredStar="*"
                        name="totalBag"
                        value={purchase.totalBag}
                        onChange={(e) => {
                          if (e.target.value.length <= 3) {
                            handlePurchaseRegistrationInput(e);
                          }
                        }}
                        maxLength={3}
                      />
                      {/* {bagPurchasedValidationError && (
                        <div className="error-message">
                          {bagPurchasedValidationError}
                        </div>
                      )} */}
                    </Col>

                    <Col xs={12} lg={6} className="mb-2">
                      <InputField
                        inputFieldLabel="Unit Price"
                        requiredStar="*"
                        name="unitPrice"
                        value={purchase.unitPrice}
                        onChange={(e) => {
                          if (e.target.value.length <= 3) {
                            handlePurchaseRegistrationInput(e);
                          }
                        }}
                        maxLength={3}
                      />
                      {/* {unitPriceValidationError && (
                        <div className="error-message">
                          {unitPriceValidationError}
                        </div>
                      )} */}
                    </Col>
                    
                    {/* <Col xs={12} lg={6} className="mb-2">
                          <Form.Label>Purchase Date</Form.Label>
                          <Form.Control
                            type="date"
                            value={purchase.purchaseDate}
                            onChange={handlePurchaseDate}
                            onKeyDown={(e) => e.preventDefault()}
                            max={new Date().toISOString().split('T')[0]}
                            min={new Date(new Date().setDate(new Date().getDate() - 15)).toISOString().split('T')[0]}
                          />
                        </Col> */}

                    {/* <Col xs={12} lg={6} className="mb-2">
                      <Form.Label>Purchase Date</Form.Label>
                      <Form.Control
                        type="date"
                        value={purchase.purchaseDate}
                        onChange={handlePurchaseDate}
                        onClick={(e) =>
                          e.target.showPicker && e.target.showPicker()
                        }
                        max={new Date().toISOString().split("T")[0]}
                        min={
                          new Date(
                            new Date().setDate(new Date().getDate() - 15)
                          )
                            .toISOString()
                            .split("T")[0]
                        }
                      />
                    </Col> */}

                    <Col xs={12} lg={6} className="mb-3">
                      <Form.Label>Purchase Date</Form.Label>
                        <DatePicker
                          defaultValue={purchase.purchaseDate} 
                          format={dateFormat}
                          disabledDate={disabledDate}
                          onKeyDown={(e) => e.preventDefault()}
                          className="w-100"
                          onChange={handlePurchaseDate}
                          style={{ height: '43px'}}
                          minDate={dayjs().subtract(pastDays, 'days')}   
                        />
                    </Col>

                    {userInfo != "Dealer" && (
                      <Col xs={12} lg={6} className="mb-2">
                        <Modal
                          labelName="Choose Dealer/ARS/Retailer"
                          requiredStar="*"
                          page="searchFilter"
                          options={dealerSelectList}
                          setSelectedValue={setIsDealerChoose}
                          selectedValue={isDealerChoose}
                          onChange={handleDealerChange}
                        />
                      </Col>
                    )}

                    <Col xs={12} lg={6} className="mb-2 position-relative">
                      <InputField
                        inputFieldLabel="Site Owner Number"
                        requiredStar="*"
                        name="mobile"
                        value={purchase.mobile}
                        onChange={(e) => {
                          if (e.target.value.length <= 10) {
                            handlePurchaseRegistrationInput(e);
                          }
                        }}
                        maxLength={10}
                      />
                      {showNumList && (
                        <ul className="number-list">
                          {allNumbers.length > 0 &&
                            allNumbers.map((num) => (
                              <li
                                key={num.id}
                                onClick={() => chooseNumber(num)}
                              >
                                {num.title}
                              </li>
                            ))}
                        </ul>
                      )}
                    </Col>

                    <Col xs={12} lg={6} className="mobileView-mb-2">
                      <InputField
                        inputFieldLabel="Site Owner Name"
                        requiredStar="*"
                        name="ownerName"
                        value={purchase.ownerName}
                        onChange={handlePurchaseRegistrationInput}
                        editable={editableSiteDetails}
                      />
                      {/* {customerNameValidationError && (
                        <div className="error-message">
                          {customerNameValidationError}
                        </div>
                      )} */}
                    </Col>

                    {/* <Col xs={12} lg={3} className="mb-2">
                      <InputField
                        inputFieldLabel="Mobile No"
                        requiredStar="*"
                        name="mobile"
                        value={purchase.mobile}
                        onChange={handlePurchaseRegistrationInput}
                      />
                      {mobileNoValidationError && (
                        <div className="error-message">
                          {mobileNoValidationError}
                        </div>
                      )}
                    </Col> */}

                    {/* <Col xs={12} lg={3} className='mb-2'>
                        <InputField
                                                inputFieldLabel="Site"
                                                requiredStar="*"
                                                name="site"
                                                value={purchase.site}
                                                onChange={handlePurchaseRegistrationInput} />
                                            {siteValidationError &&  <div className="error-message">{siteValidationError}</div>
                                             }

                                        </Col> */}

                    <Col xs={12} lg={6} className="mb-2">
                      <InputField
                        inputFieldLabel="Construction Area (Sq ft)"
                        requiredStar="*"
                        name="constructionArea"
                        value={purchase.constructionArea}
                        onChange={(e) => {
                          if (e.target.value.length <= 5) {
                            handlePurchaseRegistrationInput(e);
                          }
                        }}
                        maxLength={5}
                        editable={editableSiteDetails}
                      />
                      {/* {constructionValidationError && (
                        <div className="error-message">
                          {constructionValidationError}
                        </div>
                      )} */}
                    </Col>

                    {/* <Col xs={12} lg={6}>
                                            <SelectDropDown
                                                labelName="Persona"
                                                requiredStar='*'
                                                options={isPersonaList}
                                                setSelectedValue={setIsPersona}
                                                selectedValue={isPersona}
                                                onChange={handlePersonaChange}
                                            />
                                            {personaValidationError && (
                                                <div className="error-message">{personaValidationError}</div>
                                            )

                                            }
                                        </Col>
                                        <Col xs={12} lg={6}>
                                            <InputField
                                                inputFieldLabel="Phone Number"
                                                name="mobile"
                                                value={purchase.mobile}
                                                onChange={handlePurchaseRegistrationInput} />
                                                
                                        </Col> */}

                    <Col xs={12} lg={6} className="mt-4">
                      <PrimaryGradientButton
                        buttonText={isButtonLoading ? "Processing" : "Submit"}
                        disabled={isButtonLoading}
                        onClick={handlePurchaseRegistration}
                        loading={isButtonLoading}
                      />
                    </Col>
                    {/* {showAlert && (
                      <Col xs={12} lg={6} className="mt-4">
                        <div className="alertBoxWrap">
                          <AlertMsg
                            alertBoxColor={
                              isLoginSuccess.isLogin
                                ? "successAlert"
                                : "FailedAlert"
                            }
                            heading={isLoginSuccess.heading}
                            text={isLoginSuccess.text}
                          />
                        </div>
                      </Col>
                    )} */}
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PurchaseRegistration;
